import { startCase } from 'lodash-es'

const documentTypeLabels: Record<string, string> = {}

export const getDocumentTypeLabel = (type: string) => documentTypeLabels[type] || startCase(type)
